module.exports = __webpack_public_path__ + "static/media/copy-v2.95d6e65b.svg";